import React, {useEffect, useState} from "react";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {useParams} from "react-router-dom";
import {
    Table,
    Container,
    Row,
    Col,
    Button,
    Spinner,
    Dropdown,
    Modal,
    Form,
} from "react-bootstrap";
import {format} from "date-fns";
import axiosInstance from "../axiosInstance";
import {
    getRefreshToken,
    getTokenFromSession,
    refreshIdToken,
} from "../services/authenticate";
import {api} from "../api";
import {getOrder, updateStatusByOrderIdAndStatus, updateStatusByStockIdAndOrderType} from "../Api/orderApi";
import {deductRentForCustomer} from "../Api/accountApi";

export const Order = () => {
    const {orderId} = useParams();
    const [loading, setLoading] = useState(true);
    const [orders, setOrders] = useState([]);
    const [globalStatus, setGlobalStatus] = useState("");
    const [status, setStatus] = useState("");
    const [statusMap, setStatusMap] = useState({});
    const [deductRent, setDeductRent] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState({});
    const [show, setShow] = useState(false);
    const [damageAmount, setDamageAmount] = useState(0);
    const [dayCount, setDayCount] = useState(0);
    const [selectedDate, setSelectedDate] = useState('');

    const handleShowModal = (orderItem) => {
        setSelectedOrder(orderItem);
        setSelectedDate(orderItem.lendingEndDate || "")
        setShow(true);
    };

    // Update damage amount on input change
    const handleDamageChange = (e) => {
        setDamageAmount(e.target.value);
    };
    const convertUnixTimestampToDate = (unixTimestamp) => {
        const date = new Date(unixTimestamp * 1000);
        return format(date, "yyyy-MM-dd hh:mm:ss a");
    };

    const handleDateChange = (e) => {
        const date = new Date(e.target.value);
        setSelectedDate(format(date, 'yyyy-MM-dd'));
    };

    useEffect(() => {
        fetchOrderDetails().then();
    }, [orderId]);

    const fetchOrderDetails = async () => {
        setLoading(true);
        const response = await getOrder({orderId});
        if (response.status === 204) {
            alert(`No order details found for Order ID: ${orderId}`);
            return;
        }
        if (response.status === 200) {
            const orderDetails = response.data;
            setOrders([response.data]);
            const initialStatusMap = {};
            setGlobalStatus(orderDetails.orderStatus);
            orderDetails.lendingOrderList?.forEach((item) => {
                initialStatusMap[item.stockId] = item.status;
            });

            orderDetails.saleOrderList?.forEach((item) => {
                initialStatusMap[item.stockId] = item.status;
            });

            setStatusMap(initialStatusMap);
        }
        setLoading(false);
    };
    const handleStatusChange = (orderId, newStatus) => {
        setStatusMap((prev) => ({
            ...prev,
            [orderId]: newStatus,
        }));
    };

    const updateStatusByStockId = async (orderType, stockId, status, orderId) => {
        const body = JSON.stringify({
            orderId,
            stockId,
            status,
        })
        const response = await updateStatusByStockIdAndOrderType({body, orderType, orderId})
        alert("Status updated successfully");
        await fetchOrderDetails();
    };

    const updateOrderStatus = async (status) => {
        const body = JSON.stringify({
            orderId,
            status,
        });
        const response = await updateStatusByOrderIdAndStatus({body, orderId})
        alert("Order status updated successfully");
    };
    const handleShow = () => {
        setShow(!show);
    };
    const handleSave = async () => {
        setShow(false);
        const body = JSON.stringify({
            lendingOrderId: selectedOrder.lendingOrderId,
            customerId: selectedOrder.customerId,
            stockId: selectedOrder.stockId,
            deposit: selectedOrder.cautionDeposit,
            damageAmount: damageAmount,
            date: selectedDate,
        });
        const response = await deductRentForCustomer({body, method: "rent", orderId})
        if (response.status === 200) {
            setDeductRent(true);
            await fetchOrderDetails();
        }
    };

    const today = new Date().toISOString().split("T")[0];
    return (
        <div>
            <Header/>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            {loading ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{minHeight: "50vh"}}
                >
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            ) : orders.length === 0 ? (
                <div className="text-center mt-5 mb-5" style={{minHeight: "50vh"}}>
                    No order is found
                </div>
            ) : (
                <Container className="py-5">
                    <h3 className="text-center mb-4">Order</h3>
                    {orders.map((order) => (
                        <div key={order.orderId} className="mb-5">
                            <Row className="align-items-center mb-3">
                                <Col xs={12} md={8}>
                                    <h5>Order ID: {order.orderId}</h5>
                                    <p>Status: {order.orderStatus}</p>
                                </Col>
                                <Col xs={12} md={4} className="text-end">
                                    <p>
                                        <span>Order date: </span>
                                        {convertUnixTimestampToDate(order.orderTimestamp)}
                                    </p>
                                </Col>
                            </Row>
                            <select
                                className="form-select d-inline-block mb-3 me-2"
                                value={globalStatus || order.orderStatus}
                                onChange={(e) => setGlobalStatus(e.target.value)}
                            >
                                <option value="">Select Order Status</option>
                                <option value="CONFIRMED ">CONFIRMED</option>
                                <option value="SHIPPING_PENDING">SHIPPING_PENDING</option>
                                <option value="PICKUP_WAIT">PICKUP_WAIT</option>
                                <option value="SHIPPED">SHIPPED</option>
                                <option value="COMPLETED">COMPLETED</option>
                                <option value="FALIED">FALIED</option>
                            </select>
                            <Button
                                variant="success"
                                onClick={() => {
                                    if (globalStatus) {
                                        updateOrderStatus(globalStatus);
                                    } else {
                                        alert("Please select a status before updating.");
                                    }
                                }}
                            >
                                Update Order Status
                            </Button>

                            <Table responsive bordered hover className="mt-3">
                                <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Borrow Price</th>
                                    <th>Caution Deposit</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {order.lendingOrderList &&
                                order.lendingOrderList.length > 0 ? (
                                    <>
                                        <tr>
                                            <td
                                                colSpan="7"
                                                className="text-center fw-bold bg-light"
                                            >
                                                Lending Orders
                                            </td>
                                        </tr>
                                        {order.lendingOrderList.map((orderItem, index) => (
                                            <tr key={orderItem.isbn}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <img
                                                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}${orderItem.isbn}.jpg`}
                                                        alt={orderItem.title || "Book Image"}
                                                        style={{width: "50px", height: "auto"}}
                                                    />
                                                </td>
                                                <td>{orderItem.title || "Unknown Title"}</td>
                                                <td>₹{orderItem.lendingPricePerDay}</td>
                                                <td>
                                                    ₹{orderItem.cautionDeposit}
                                                </td>
                                                <td>
                                                    <select
                                                        className="form-select"
                                                        value={statusMap[orderItem.stockId] || ""}
                                                        onChange={(e) =>
                                                            handleStatusChange(
                                                                orderItem.stockId,
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value="ORDER_CONFIRMED">
                                                            ORDER_CONFIRMED
                                                        </option>
                                                        <option value="PICKUP_WAIT">PICKUP_WAIT</option>
                                                        <option value="SHIPPED">SHIPPED</option>
                                                        <option value="LENDING_STARTED">
                                                            LENDING_STARTED
                                                        </option>
                                                        <option value="REVERSE_PICKUP_WAIT">
                                                            REVERSE_PICKUP_WAIT
                                                        </option>
                                                        <option value="REVERSE_SHIPPED">
                                                            REVERSE_SHIPPED
                                                        </option>
                                                        <option value="REVERSE_PICKUP">
                                                            REVERSE_PICKUP
                                                        </option>
                                                        <option value="LENDING_COMPLETED">LENDING_COMPLETED</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <div style={{display: "flex", alignItems: "center"}}>
                                                        <Button
                                                            variant="success"
                                                            onClick={() =>
                                                                updateStatusByStockId(
                                                                    "lending",
                                                                    orderItem.stockId,
                                                                    statusMap[orderItem.stockId],
                                                                    orderItem.lendingOrderId
                                                                )
                                                            }
                                                        >
                                                            Update
                                                        </Button>
                                                        {(orderItem.status === "REVERSE_PICKUP_WAIT" || orderItem.status === "REVERSE_SHIPPED" || orderItem.status === "REVERSE_PICKUP") && (
                                                            <div>
                                                                <button
                                                                    onClick={() => handleShowModal(orderItem)}
                                                                    style={{
                                                                        marginLeft: "10px",
                                                                        padding: "5px 10px",
                                                                        backgroundColor: "blue",
                                                                        color: "white",
                                                                        border: "none",
                                                                        borderRadius: "5px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    Deduct Rent
                                                                </button>
                                                            </div>
                                                        )}
                                                        {deductRent && <p>Rent deducted!</p>}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No Lending Orders Found
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>

                            {/* Selling Orders Table */}
                            <Table responsive bordered hover className="mt-3">
                                <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Image</th>
                                    <th>Title</th>
                                    <th>Buy Price</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {order.saleOrderList && order.saleOrderList.length > 0 ? (
                                    <>
                                        <tr>
                                            <td
                                                colSpan="6"
                                                className="text-center fw-bold bg-light"
                                            >
                                                Selling Orders
                                            </td>
                                        </tr>
                                        {order.saleOrderList.map((orderItem, index) => (
                                            <tr key={orderItem.isbn}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <img
                                                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}${orderItem.isbn}.jpg`}
                                                        alt={orderItem.title || "Book Image"}
                                                        style={{width: "50px", height: "auto"}}
                                                    />
                                                </td>
                                                <td>{orderItem.title || "Unknown Title"}</td>
                                                <td>₹{orderItem.sellingPrice}</td>
                                                <td>
                                                    <select
                                                        className="form-select"
                                                        value={statusMap[orderItem.stockId] || ""}
                                                        onChange={(e) =>
                                                            handleStatusChange(
                                                                orderItem.stockId,
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">Select Status</option>
                                                        <option value="ORDER_CONFIRMED">
                                                            ORDER_CONFIRMED
                                                        </option>
                                                        <option value="PICKUP_WAIT">PICKUP_WAIT</option>
                                                        <option value="SHIPPED">SHIPPED</option>
                                                        <option value="SOLD">SOLD</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <Button
                                                        variant="success"
                                                        onClick={() =>
                                                            updateStatusByStockId(
                                                                "sale",
                                                                orderItem.stockId,
                                                                statusMap[orderItem.stockId],
                                                                orderItem.saleOrderId
                                                            )
                                                        }
                                                    >
                                                        Update
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            No Selling Orders Found
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        </div>
                    ))}
                </Container>
            )}
            <Modal show={show} onHide={handleShow}>
                <Modal.Header closeButton>
                    <Modal.Title>Deduct Rent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="lendingOrderId">
                            <Form.Label>Order ID</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedOrder.lendingOrderId}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group controlId="customerId">
                            <Form.Label>Customer ID</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedOrder.customerId}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group controlId="stockId">
                            <Form.Label>Stock ID</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedOrder.stockId}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group controlId="deposit">
                            <Form.Label>Deposit</Form.Label>
                            <Form.Control
                                type="text"
                                value={selectedOrder.cautionDeposit}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group controlId="selectedDate">
                            <Form.Label>Rent Date</Form.Label>
                            <Form.Control
                                type="date"
                                onChange={handleDateChange}
                                value={selectedDate}
                                required
                                max={today}
                            />
                        </Form.Group>

                        <Form.Group controlId="damageAmount">
                            <Form.Label>Damage Amount</Form.Label>
                            <Form.Control
                                type="number"
                                value={damageAmount}
                                onChange={handleDamageChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleShow}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
